export default __webpack_public_path__ + "static/media/Hot-Mop-Decks.c89abfcb.jpg";